import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { BannerService, BannerServiceStatus, Message } from 'src/app/services/banner.service';
@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements AfterViewInit {
  public get Messages(): Message[] | [] {
    return this.bannerService.Messages
  }

  constructor(private bannerService: BannerService,
    @Inject(DOCUMENT) private document: any) { }

  ngAfterViewInit(): void {
  }
}
